<template>
<BCard>
  <!-- Correo de prueba -->
  <BButton v-b-modal.test-modal variant="primary" class="mb-2"> Enviar correo de prueba </BButton>
  <BModal id="test-modal" centered hide-footer title="Enviar correo de prueba">
    <BForm @submit.prevent="onSendTestMail">  
      <BFormGroup class="mb-2">
        <label for="email">Email:</label>
        <BFormInput id="email" type="email" placeholder="Dirección de correo" />
      </BFormGroup>
      <BButton variant="danger" @click="$bvModal.hide('test-modal')">Cancelar</BButton>
      <BButton type="submit" variant="primary">Enviar</BButton>
    </BForm>
  </BModal>

  <BForm @submit.prevent>
    <BRow>

      <!-- mailer -->
      <BCol cols="6">
        <BFormGroup :label="$t('Mail Mailer')" label-for="mail_mailer" >
          <BFormInput id="mail_mailer" placeholder="Mail Mailer" v-model="settings.mail_mailer" />
        </BFormGroup>
      </BCol>

      <!-- host -->
      <BCol cols="6">
        <BFormGroup :label="$t('Mail Host')" label-for="mail_host" >
          <BFormInput id="mail_host" placeholder="Mail Host" v-model="settings.mail_host" />
        </BFormGroup>
      </BCol>
      
      <!-- port -->
      <BCol cols="6">
        <BFormGroup :label="$t('Mail Port')" label-for="mail_port" >
          <BFormInput id="mail_port" placeholder="Mail Port" v-model="settings.mail_port"/>
        </BFormGroup>
      </BCol>

      <!-- username -->
      <BCol cols="6">
        <BFormGroup :label="$t('Mail Username')" label-for="mail_username" >
          <BFormInput id="mail_username" placeholder="Mail Username" v-model="settings.mail_username"/>
        </BFormGroup>
      </BCol>

      <!-- password -->
      <BCol cols="6">
        <BFormGroup :label="$t('Mail Password')" label-for="mail_password" >
          <BFormInput id="mail_password" placeholder="Mail Password" type="password" v-model="settings.mail_password"/>
        </BFormGroup>
      </BCol>

      <!-- encryption -->
      <BCol cols="6">
        <BFormGroup :label="$t('Mail Encryption')" label-for="mail_encryption" >
          <BFormInput id="mail_encryption" placeholder="Mail Encryption" v-model="settings.mail_encryption"/>
        </BFormGroup>
      </BCol>

      <!-- from adress -->
      <BCol cols="6">
        <BFormGroup :label="$t('Mail From Address')" label-for="mail_from_address" >
          <BFormInput id="mail_from_address" placeholder="Mail From Address" v-model="settings.mail_from_address"/>
        </BFormGroup>
      </BCol>

      <!-- from name -->
      <BCol cols="6">
        <BFormGroup :label="$t('Mail From Name')" label-for="mail_from_name" >
          <BFormInput id="mail_from_name" placeholder="Mail From Name" v-model="settings.mail_from_name"/>
        </BFormGroup>
      </BCol>

      <!-- submit and reset -->
      <BCol cols="12" class="mt-2">
        <BButton v-ripple.400="'rgba(255, 255, 255, 0.15)'" type="submit" variant="primary" class="mr-1" @click="onSubmit"> {{ $t('Submit') }} </BButton>
        <BButton v-ripple.400="'rgba(186, 191, 199, 0.15)'" type="reset" variant="outline-secondary" > {{ $t('Reset') }} </BButton>
      </BCol>
    </BRow>
  </BForm>
</BCard>
</template>

<script>
import { BCard, BRow, BCol, BFormGroup, BFormInput, BForm, BButton, BModal, } from 'bootstrap-vue'
import { inject } from '@vue/composition-api'
import { sendTestMail } from '@/composables/settingsService'
import Ripple from 'vue-ripple-directive'
import popups from '@/hooks/popups'
import store from '@/store'

export default {
  components: { BRow, BCol, BCard, BFormGroup, BFormInput, BForm, BButton, BModal },
  directives: { Ripple },
  setup(){
    const { errorToast, successToast } = popups()
    const settings = inject('settings')

    /**
     * Actualizar ajustes
     */
    const onSubmit = function(){
      store.dispatch('settings/updateSettings', JSON.parse(JSON.stringify(settings.value)))
        .then(response => { successToast('Configuración de correos actualizada.') })
        .catch(response => { errorToast('No se puede actualizar la configuración de correo.') })
    }

    /**
     * Enviar correo de prueba
     * @param {FormEvent} event 
     */
    const onSendTestMail = async function(event) {
      let email = event.target.elements.email.value
      let res = await sendTestMail(email)
      if (res.success) {
        successToast('Email enviado correctamente')
      } else {
        errorToast('Ha habido un error al enviar el correo: ' + res.error)
      }
    }

    return {
      onSubmit,
      onSendTestMail,
      settings
    }
  },
}
</script>
